import { useCallback } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useLookupOptionsSearch = () => {
  const { apiPost } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const searchLookupOptions = useCallback(
    async ({ lookupSource, query, limit = 20 }) => {
      if (!lookupSource || !query || query.trim().length < 2) {
        const response = {
          data: { options: [], totalCount: 0 },
          error: null,
        };
        setResponse(response);
        return response;
      }

      startLoading();

      const response = await apiPost("/api/v1/lookups/search", "Error al consultar opciones del lookup", {
        lookup_source: lookupSource,
        query,
        limit,
      });

      setResponse(response);
      return response;
    },
    [apiPost, setResponse, startLoading],
  );

  return {
    searchLookupOptions,
    data,
    error,
    loading,
  };
};

export default useLookupOptionsSearch;
